module.exports = __webpack_public_path__ + "static/media/confirmation-btn.63f3143b.svg";